import { connect } from 'react-redux';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Polygon } from '@tcc/treadstone';
import { Spinner } from '@tcc/crate';
import styles from './SoilSsurgoMap.css';
import { reqSoilSsurgoZones } from '../../../../actions/mosaicActions';
import { BASE_LAYERS } from '../../../../constants/mapLayerIds';
import { SEASON_AGNOSTIC } from '../../../../constants/seasonIds';

const LAYER = BASE_LAYERS.SOIL_SSURGO;

export class SoilSsurgoMap extends Component {
  UNSAFE_componentWillMount() {
    const {
      imageId,
      zones,
      reqSoilSsurgoZones: reqSoilSsurgoZonesProp,
    } = this.props;
    if (!zones) {
      reqSoilSsurgoZonesProp(imageId);
    }
  }

  render() {
    const { activeZoneIndex, zones } = this.props;
    if (!zones) {
      return <Spinner className={styles.loading} color="white" size="200px" />;
    }

    return (
      <div>
        {zones.map((zone, index) => {
          const isActive = index === activeZoneIndex;
          return (
            <Polygon
              color="white"
              fillColor={zone.color}
              fillOpacity={isActive ? 0.5 : 0.3}
              key={zone.color}
              positions={zone.coordinates}
              weight={isActive ? 4 : 1}
            />
          );
        })}
      </div>
    );
  }
}

SoilSsurgoMap.propTypes = {
  activeZoneIndex: PropTypes.number.isRequired,
  imageId: PropTypes.string.isRequired,
  reqSoilSsurgoZones: PropTypes.func.isRequired,
  zones: PropTypes.array,
};

function mapStateToProps(state, props) {
  const { activeSubLayerIds, imageId, zones } =
    state.layers.list[SEASON_AGNOSTIC][LAYER];
  return {
    activeZoneIndex: activeSubLayerIds[props.index],
    imageId,
    zones,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      reqSoilSsurgoZones,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SoilSsurgoMap);
